import { DNOTE_SERVICE_URL } from 'constants/urls';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Link as RouterLink } from 'react-router-dom';
import { Alert } from 'shared/mui/Alert/Alert';
import { Card, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { ClickAwayListener } from 'shared/mui/ClickAwayListener/ClickAwayListener';
import { TextFieldWithCopyButton } from 'shared/mui/Fields';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Link } from 'shared/mui/Link/Link';

type NotificationKeyTooltipCardProps = {
  value?: string;
  onClose: () => void;
};

export const NotificationKeyTooltipCard: React.FC<NotificationKeyTooltipCardProps> = ({
  value,
  onClose,
}) => {
  const translate = useTypedTranslate();

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Card
        sx={{
          width: '444px',
        }}
      >
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          sx={{ padding: '16px 24px 8px 24px' }}
          title={translate('app.merchants.notificationKey')}
          titleSize="small"
        />
        <CardContent sx={{ padding: '16px 24px 24px 24px !important' }}>
          <TextFieldWithCopyButton
            disabled
            fullWidth
            size="medium"
            sx={{ marginTop: 0 }}
            value={value}
            variant="outlined"
          />
          <Alert severity="info" sx={{ marginTop: '16px' }}>
            {translate('app.merchants.useInternalService')}{' '}
            <Link
              component={RouterLink}
              sx={{ color: 'primary.main' }}
              target="_blank"
              to={DNOTE_SERVICE_URL}
            >
              DNOTE
            </Link>{' '}
            {translate('app.merchants.toPassApiKeyValue')}.
          </Alert>
        </CardContent>
      </Card>
    </ClickAwayListener>
  );
};
